// extracted by mini-css-extract-plugin
export default {"container":"alt-button-group__container___3Jp-M"};